import { Button, Container } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Datagrid, List, TextField, useListContext, useListController, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { FormattedTextFieldWithStatus } from '../../sales/reservation/helper/FormattedTextFieldWithStatus'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { ItemSupplierFilters, PostFilterFormItemSupplier } from './logic/ItemSupplierFilter'
import { Download } from '@mui/icons-material'
import * as XLSX from "xlsx"
import { FunctionField } from 'react-admin';

const CustomExportButton = () =>{
  const translate = useTranslate()
  const controller = useListController()

  const sinTildes = (texto) =>
  texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")

  const handleExport = () =>{
    const rows = controller.data?.map(row=>({
      [sinTildes(translate(`ra.field.supplier`))]:row.supplier_name,
      [sinTildes(translate(`ra.field.status`))]:row.status && translate(`ra.status.${row.status}`),
      [sinTildes(translate(`ra.field.number`))]:row.number,
      [sinTildes(translate(`ra.field.code`))]:row.code,
      [sinTildes(translate(`ra.field.currency`))]:row.currency_relation?.short_name,
      [sinTildes(translate(`ra.field.total`))]:row.amount_total,
      [sinTildes(translate(`ra.field.amount_paid`))]:row.amount_paid,
      [sinTildes(translate(`ra.field.amount_pending`))]:row.amount_pending,
      [sinTildes(translate(`ra.field.due_date`))]:row.due_date,
      [sinTildes(translate(`ra.field.start_date`))]:row.date_in,
      [sinTildes(translate(`ra.field.end_date`))]:row.date_out,
      [sinTildes(translate(`ra.field.detail`))]:row.detail.name,
      [sinTildes(translate(`ra.field.created_at`))]:row.created_at ? row.created_at.split('T')[0] :''
    }))
    if (!rows || !rows.length){
      return
    } 

    
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, "Datos")
    XLSX.writeFile(wb, "export.xlsx")

    /* const headers = Object.keys(rows[0])

    const csvContent = [
      headers.join(","), // encabezados
      ...rows.map(row =>
        headers.map(field => `"${row[field] ?? ""}"`).join(",")
      )
    ].join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = url
    link.download = 'suppliers_account_state_export.csv'
    setLoading(false)
    link.click()

    URL.revokeObjectURL(url) */
  } 
  return (
    <Button
      onClick={handleExport}
      startIcon={<Download fontSize='small' />}
      sx={{ lineHeight: '1.5'}}
      size='small'
    >
      {translate('ra.action.export')}
    </Button>
  )
}

export const ItemSupplierList = (props) => {
    const translate = useTranslate()
    const { isFetching, page, filterValues} = useListContext()
    const prevPageRef = useRef()
    const prevFiltersRef = useRef(filterValues)
    
    const [pageChanged, setPageChanged] = useState(false)

    const allFilters = [
        { source: 'supplier_id', name: 'ra.field.supplier' },
        { source: 'created_at', name: 'ra.field.created_at' },
        { source: 'status', name: 'ra.field.status' },
        { source: 'due_date', name: 'ra.field.due_date' },
        { source: 'reservation__number__in', name: 'ra.field.number' },
        { source: 'code__in', name: 'ra.field.code' },
        { source: 'item__date_in', name: 'ra.field.start_date' },
        { source: 'item__date_out', name: 'ra.field.end_date' },
        { source: 'currency_id', name: 'ra.field.currency' },
    ]
    
    useEffect(() => {
        // Comprobar si la página ha cambiado y si isFetching es true
        if (prevPageRef.current !== page && isFetching) {
        prevPageRef.current = page
        setPageChanged(true)
        }
        if (prevFiltersRef.current !== filterValues && isFetching) {
        prevFiltersRef.current = filterValues
        setPageChanged(true)
        } else {
        setPageChanged(false)
        }
    }, [isFetching, page, filterValues])
  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.item-supplier')}>
        <List {...props} sort={{field: 'id', order: 'DESC'}} component='div' 
            actions={
                <ListViewTopToolbar 
                    customFilter 
                    FilterFormComponent={PostFilterFormItemSupplier} 
                    FilterButtonComponent={ItemSupplierFilters} 
                    listFilters={allFilters}
                    CustomExportButton={CustomExportButton}
                    exporterDisable={true}
                />
            }>
          <Datagrid  bulkActionButtons={false} isLoading={pageChanged}>
            <TextField source='supplier_name' label={translate('ra.field.supplier')}/>
            <FormattedTextFieldWithStatus label={translate('ra.field.status')} source='status' />
            <TextField source='number' label={translate('ra.field.number')} />
            <FunctionField 
                label={translate('ra.field.code')} 
                render={record => record?.code ?? record?.detail?.code} 
            />
            <TextField source='currency_relation.short_name' label={translate('ra.field.currency')} />
            <TextField source='amount_total' label={translate('ra.field.total')} />
            <TextField source='amount_paid' label={translate('ra.field.amount_paid')} />
            <TextField source='amount_pending' label={translate('ra.field.amount_pending')} />
            <TextField source='due_date' label={translate('ra.field.due_date')} />
            <TextField source='date_in' label={translate('ra.field.start_date')} />
            <TextField source='date_out' label={translate('ra.field.end_date')} />
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
